import { render, staticRenderFns } from "./coderReviewList.vue?vue&type=template&id=2e98b760&scoped=true&"
import script from "./coderReviewList.vue?vue&type=script&lang=js&"
export * from "./coderReviewList.vue?vue&type=script&lang=js&"
import style0 from "./coderReviewList.vue?vue&type=style&index=0&id=2e98b760&scoped=true&lang=css&"
import style1 from "./coderReviewList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e98b760",
  null
  
)

export default component.exports